import React, { useEffect, useState } from "react";
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import getBackendUrl from "../../../../environment/BackendService";
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";


const useCostType = () => {
  const [data, setData] = useState([]); /* Cost Type Data */
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({
    searchCriteria: "",
  }); /* */
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { ADD_COST_TYPE, DISPLAY_COST_TYPE } = ROUTE_PATHS;

  const screen_title = "Cost Type";
  const screenNumber = "RCCOT004";

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "COT Cost Type",
      name: "searchCriteria",
      label: "Cost Type",
      type: "text",
      fieldNature: "editable",
      value: "",
      maxLength: 10,
    },
  ];

  /* Dropdown options fields that needs to be fetched with API */
  const dropdownOptions = [];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        navigateToPage("Back");
      },
      button_key: "F12",
    },
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },
  ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = [
    {
      label: "Select",
      icon: <span className="material-icons">add</span>,
      command: () => {
        navigateToPage(DISPLAY_COST_TYPE, {
          selectedCostTypes: selectedRows.length
            ? selectedRows
            : [rowData.cotCostType],
          previousScreen: location.pathname,
        });
      },
    },
    {
      label: "Display",
      icon: <span className="material-icons">display</span>,
      command: () => {
        navigateToPage(DISPLAY_COST_TYPE, {
          selectedCostTypes: selectedRows.length
            ? selectedRows
            : [rowData.cotCostType],
          previousScreen: location.pathname,
        });
      },
    },
  ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Cost Type",
      field: "type",
    },
    {
      header: "Description",
      field: "description",
    },
  ];

  /* Param Key which used as bridge between various operations on tabular data */
  const parmKey = "cotCostType";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/rccotp`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage, selectedOption]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteCostType = () => {
    if (selectedOption === "yes") {
      const params = { cotCostType: rowData[parmKey] };
      axios_helper_no_header("DELETE", "api/costtype", null, params)
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: error.message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rccotp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteCostType,
    setSelectedOption,
  };
};

export default useCostType;
